import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2.5fr 1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    },
    background: theme.palette.grey[200],
    margin: '8px 0px',
    borderRadius: 8
  },
  facilityText: { color: theme.palette.info.main, fontWeight: 500 },
  btn: {
    textTransform: 'none',
    padding: 0,
    fontSize: 14,
    marginLeft: 4,
    display: 'inline',
    minWidth: 'auto',
    color: theme.palette.info.main
  },
  property: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px'
  },
  secondaryTitle: {
    color: theme.palette.text.primary,
    fontSize: 18,
    margin: '10px 0px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    }
  },
  greyText: { color: theme.palette.grey[600] },
  facilitiy: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  policies: {
    display: 'flex',
    flexDirection: 'column',
    padding: '2px 16px'
  },
  primaryTitle: {
    margin: '15px 0px',
    color: theme.palette.text.primary,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    }
  },
  icon: { marginRight: 4, fontSize: 18, padding: 0 },
  check: { display: 'flex', alignItems: 'center' },
  whiteDiv: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    marginBottom: 8,
    padding: 5,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8
  }
}))
export default useStyles
